import React from 'react';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { AccountBalanceWallet as WalletIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useOutstandingBalance } from '../../contexts/OutstandingBalanceContext';
import { balanceProfilePath, formatDueDate, formatMoney } from '../../utils/outstandingBalance';

/** Home dashboard summary of the signed-in member's overdue balance. Hidden when nothing is owed. */
const OutstandingBalanceCard = ({ sx = {} }) => {
  const { balance, userTenantId } = useOutstandingBalance();
  const total = balance?.totalOverdueCents || 0;
  const profilePath = balanceProfilePath(userTenantId);

  if (total <= 0 || !profilePath) return null;

  const invoices = balance.invoices || [];
  const oldestDue = invoices.reduce((oldest, i) => (!oldest || i.dueDate < oldest ? i.dueDate : oldest), null);

  return (
    <Paper
      sx={{ p: 2, borderLeft: 4, borderColor: 'error.main', ...sx }}
      data-testid="outstanding-balance-card"
    >
      <Stack spacing={1.5}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <WalletIcon color="error" />
          <div>
            <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
              You owe {formatMoney(total)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {invoices.length} overdue invoice{invoices.length === 1 ? '' : 's'}
              {oldestDue ? ` · oldest due ${formatDueDate(oldestDue)}` : ''}
            </Typography>
          </div>
        </Stack>
        <Button component={Link} to={profilePath} variant="contained" color="error" size="small" fullWidth>
          View &amp; pay
        </Button>
      </Stack>
    </Paper>
  );
};

export default OutstandingBalanceCard;
